import { useState } from 'react'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'

export const useStatusFilter = updateFilters => {
	const { t } = useTranslation()
	const [selectedStatus, setSelectedStatus] = useState('')

	const statusOptions = [
		{ value: 'issued', label: t('korekty.list.statusFilter.options.issued') },
		{ value: 'overdue', label: t('korekty.list.statusFilter.options.overdue') },
		{ value: 'paid', label: t('korekty.list.statusFilter.options.paid') },
	]

	const handleStatusFilter = () => {
		const radioButtonsHtml = statusOptions
			.map(
				status => `
            <div style="text-align: left; margin-bottom: 10px;">
                <label style="display: flex; align-items: center; cursor: pointer;">
                    <input type="radio" name="status" id="status-${status.value}" value="${status.value}" 
                           ${selectedStatus === status.value ? 'checked' : ''} 
                           style="margin-right: 8px;">
                    <span>${status.label}</span>
                </label>
            </div>
        `
			)
			.join('')

		Swal.fire({
			title: t('korekty.list.statusFilter.title'),
			html: `
                <div style="text-align: left;">
                    <div style="margin-bottom: 10px">${t('korekty.list.statusFilter.prompt')}</div>
                    ${radioButtonsHtml}
                </div>
            `,
			showCancelButton: true,
			showDenyButton: true,
			confirmButtonText: t('korekty.list.statusFilter.apply'),
			denyButtonText: t('korekty.list.statusFilter.clear'),
			cancelButtonText: t('korekty.list.statusFilter.cancel'),
			customClass: {
				denyButton: 'swal2-deny',
			},
			preConfirm: () => {
				const selectedRadio = document.querySelector('input[name="status"]:checked')
				return selectedRadio ? selectedRadio.value : ''
			},
		}).then(result => {
			if (result.isDenied) {
				setSelectedStatus('')
				updateFilters({ status: null })
			} else if (result.isConfirmed) {
				const newSelectedStatus = result.value || ''

				setSelectedStatus(newSelectedStatus)

				if (newSelectedStatus) {
					updateFilters({ status: newSelectedStatus })
				} else {
					updateFilters({ status: null })
				}
			}
		})
	}

	const getStatusDisplay = () => {
		if (!selectedStatus) return ''
		const status = statusOptions.find(opt => opt.value === selectedStatus)
		return status ? status.label : selectedStatus
	}

	return {
		selectedStatus,
		handleStatusFilter,
		getStatusDisplay,
	}
}
